import React from 'react';
import { Bars } from '@clockout-dev/design-elements';
import { CASHFLOW_SERIES } from '../treasury.constants';

/**
 * Cashflow-specific bar chart. Pure adapter: maps the
 * `{ bucket, inflow, outflow }` rows returned by the GL Account
 * controller into the `{ bucket, label, value }[]` shape the shared
 * `Bars` component expects, and supplies a currency tooltip formatter.
 *
 * `null` / `undefined` series values are skipped so the chart only
 * renders the points it actually has, instead of stacking zero bars.
 */
function CashflowBars({ rows = [], height = 280 }) {
    const data = rows.flatMap((row) => CASHFLOW_SERIES
        .filter((item) => row?.[item.key] !== undefined && row?.[item.key] !== null)
        .map((item) => ({
            bucket: row.bucket,
            label: item.label,
            value: row[item.key],
        })));

    const series = CASHFLOW_SERIES.map(({ label, color }) => ({ label, color }));

    return (
        <Bars
            data={data}
            series={series}
            height={height}
            formatValue={(value) => `$${Number(value || 0).toLocaleString('en-US')}`}
        />
    );
}

export default CashflowBars;
